import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Footer from './Footer';

const milestones = [
  {
    id: 1,
    year: "2012",
    endYear: "2016",
    title: "FineLine Retail",
    category: "Omni-Channel eCommerce",
    description: "Co-founded an omnichannel eCommerce company. Launched 20+ private label products, shipped 150,000+ orders with 99% positive feedback, and generated ~$2M in Annual Gross Merchandise Volume (GMV).",
    link: "https://www.youtube.com/watch?v=9HxjMP5f5ZE",
  },
  {
    id: 2,
    year: "2017",
    endYear: "2018",
    title: "Crypto Answers",
    category: "Publication",
    description: "Started a cryptocurrency blog that accrued 7,000+ followers and 35,000+ pageviews / month with $0 in ad spend.",
    link: "https://www.youtube.com/watch?v=R1CBfyPQmcM",
  },
  {
    id: 3,
    year: "2019",
    endYear: "2021",
    title: "Project Sherpa",
    category: "Content and SEO",
    description: "As a Google Certified Project Sherpa, delivered SEO and content marketing campaigns for enterprise clients like Adobe Express and Google, as well as local, small business owners.",
    link: "https://www.youtube.com/watch?v=tPQcWfj9mcA",
  },
  {
    id: 4,
    year: "2022",
    endYear: "2023",
    title: "sygn",
    category: "Out of Home (OOH) Revenue Share Model",
    description: "Tinkered in MadTech and developed a novel Out-of-Home (OOH) revenue share model that sought to aid in the funneling and distribution of surplus advertising budgets to over 1 million homeowners in the United States and Canada.",
    link: "/sygn",
  },
  {
    id: 5,
    year: "2026",
    endYear: "Present",
    title: "midpantry",
    category: "Commercial Kitchen Operations",
    description: "In approaching Whiteheadian Concrescence; developed a model that deep-cleans, rotates, and resupplies commercial kitchens.\n\nThis model is the final touchpoint for a laterally derived existence consisting of matter found in the Periodic Table of Elements developed by Dmitri Mendeleev in 1869.\n\nThis model can be used across a variety of industry verticals to smooth the hysteresis error found in complex maintenence and sustainment processes and minimize unneccessary convolution.\n\nThis model is as nimble as it is elastic, and allows for the preservation of independent and private ownership for those with aptitude.",
    link: null,
  }
];

const RoadmapPage = () => {
  useEffect(() => {
    document.title = 'Roadmap — Alan Shteynberg';
    return () => { document.title = 'Alan was here.'; };
  }, []);

  return (
    <div className="roadmap-page" data-testid="roadmap-page">
      <header className="roadmap-header">
        <Link to="/" className="back-button" data-testid="roadmap-back-button">
          <ArrowLeft size={20} />
          <span>Back to Home</span>
        </Link>
      </header>

      <main className="roadmap-main">
        <h1 className="roadmap-title">
          ROAD<span className="title-faded">MAP</span>
        </h1>

        <div className="timeline">
          {milestones.map((m, i) => {
            const hasLink = m.link !== null;
            const isInternal = hasLink && m.link.startsWith('/');
            const CardTag = hasLink ? (isInternal ? Link : 'a') : 'div';
            const linkProps = hasLink
              ? (isInternal ? { to: m.link } : { href: m.link, target: "_blank", rel: "noopener noreferrer" })
              : {};

            return (
              <div className={`timeline-item ${i % 2 === 0 ? 'left' : 'right'}`} key={m.id} data-testid={`milestone-${m.id}`}>
                <div className="timeline-dot"></div>
                <CardTag className={`timeline-card ${hasLink ? 'timeline-card-link' : ''}`} {...linkProps}>
                  <span className="timeline-year">{m.year} — {m.endYear}</span>
                  <h2 className="timeline-card-title">{m.title}</h2>
                  <p className="timeline-category">{m.category}</p>
                  {m.description.split('\n\n').map((para, idx) => (
                    <p className="timeline-desc" key={idx}>{para}</p>
                  ))}
                </CardTag>
              </div>
            );
          })}
        </div>
      </main>

      <Footer />

      <style jsx>{`
        .roadmap-page {
          min-height: 100vh;
          background: #151312;
          padding: 24px;
        }

        .roadmap-header {
          max-width: 900px;
          margin: 0 auto 40px;
        }

        .back-button {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: transparent;
          border: 1px solid rgba(182, 180, 189, 0.3);
          color: #998f8f;
          padding: 10px 16px;
          border-radius: 8px;
          font-family: 'Poppins', sans-serif;
          font-size: 14px;
          text-decoration: none;
          transition: all 0.2s ease;
        }

        .back-button:hover {
          border-color: #f46c38;
          color: #f46c38;
        }

        .roadmap-main {
          max-width: 900px;
          margin: 0 auto;
        }

        .roadmap-title {
          font-family: 'Poppins', sans-serif;
          font-size: clamp(36px, 6vw, 56px);
          font-weight: 700;
          color: #fff;
          line-height: 1;
          letter-spacing: -0.02em;
          margin: 0 0 60px 0;
          text-align: center;
        }

        .title-faded {
          color: rgba(182, 180, 189, 0.2);
        }

        .timeline {
          position: relative;
          padding: 0;
        }

        .timeline::before {
          content: '';
          position: absolute;
          left: 50%;
          top: 0;
          bottom: 0;
          width: 2px;
          background: rgba(244, 108, 56, 0.2);
          transform: translateX(-50%);
        }

        .timeline-item {
          position: relative;
          width: 50%;
          padding: 0 40px 60px;
          box-sizing: border-box;
        }

        .timeline-item.left {
          left: 0;
          text-align: right;
          padding-right: 48px;
          padding-left: 0;
        }

        .timeline-item.right {
          left: 50%;
          text-align: left;
          padding-left: 48px;
          padding-right: 0;
        }

        .timeline-dot {
          position: absolute;
          top: 6px;
          width: 14px;
          height: 14px;
          border-radius: 50%;
          background: #f46c38;
          border: 3px solid #151312;
          z-index: 1;
        }

        .timeline-item.left .timeline-dot {
          right: -7px;
        }

        .timeline-item.right .timeline-dot {
          left: -7px;
        }

        .timeline-card {
          display: block;
          padding: 24px;
          background: rgba(255, 255, 255, 0.02);
          border: 1px solid rgba(182, 180, 189, 0.1);
          border-radius: 12px;
          text-decoration: none;
          transition: border-color 0.2s ease, transform 0.2s ease;
        }

        .timeline-card-link:hover {
          border-color: rgba(244, 108, 56, 0.4);
          transform: translateY(-2px);
        }

        .timeline-year {
          font-family: 'Poppins', sans-serif;
          font-size: 13px;
          font-weight: 600;
          color: #f46c38;
          letter-spacing: 0.5px;
        }

        .timeline-card-title {
          font-family: 'Poppins', sans-serif;
          font-size: 22px;
          font-weight: 700;
          color: #fff;
          margin: 8px 0 4px 0;
          line-height: 1.2;
        }

        .timeline-category {
          font-family: 'Poppins', sans-serif;
          font-size: 13px;
          color: #998f8f;
          margin: 0 0 12px 0;
        }

        .timeline-desc {
          font-family: 'Poppins', sans-serif;
          font-size: 14px;
          color: rgba(182, 180, 189, 0.7);
          line-height: 1.7;
          margin: 0 0 12px 0;
        }

        .timeline-desc:last-child {
          margin-bottom: 0;
        }

        @media (max-width: 768px) {
          .roadmap-page {
            padding: 20px;
          }

          .timeline::before {
            left: 16px;
          }

          .timeline-item {
            width: 100%;
            padding: 0 0 40px 48px;
          }

          .timeline-item.left,
          .timeline-item.right {
            left: 0;
            text-align: left;
            padding-left: 48px;
            padding-right: 0;
          }

          .timeline-item.left .timeline-dot,
          .timeline-item.right .timeline-dot {
            left: 9px;
            right: auto;
          }

          .timeline-card-title {
            font-size: 18px;
          }

          .timeline-desc {
            font-size: 13px;
          }
        }

        @media (max-width: 600px) {
          .roadmap-page {
            padding: 16px;
          }

          .roadmap-title {
            margin-bottom: 40px;
          }

          .timeline-card {
            padding: 16px;
          }
        }
      `}</style>
    </div>
  );
};

export default RoadmapPage;
